module.exports = __webpack_public_path__ + "media/images/new/filter_by_reported_cell_service@2x-1ddc432439c963076278c1c1b0cb0918.jpg";